// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/home-1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-styled-container {
  display: flex;
  flex-direction: column;
  position: relative;

}

.home-styled-content {
  position: relative;
  z-index: 2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  width: 100%;
  height: 850px;
  flex-direction: column;
  overflow: hidden;
  border-radius: 100px;
  padding: 20px 0px 20px 20px;
}

.home-styled-back {
  z-index: 1;
  position: absolute;
  background-color: #000204;
  width: 100%;
  height: 200px;
}

.home-background-circle {
  position: absolute;
  z-index: 3;
  height: 850px;
  width: 850px;
  background: linear-gradient(180deg, #0060b3 0%, #000204 100%);
  border-radius: 700px;
  right: -150px;
  top: 100px;

}

.home-styled-content .home-background-phone {
  position: absolute;
  
  right: 50px;
  top: -20px;
  z-index: 4;
}

.home-main-content {
  display: flex;
  gap: 20px;
  position: absolute;
  z-index: 3;
}

.home-content-container {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 61%;
  margin-left: 0px;
  padding: 100px 0px 0px 100px;
}

.home-text-container {
  position: relative;
  display: flex;
  margin-top: 29px;
  flex-direction: column;
  font-family: 'Livvic';
  color: rgba(255, 255, 255, 1);
}

.home-title {
  font-size: 56px;
  font-weight: 700;
  line-height: 63px;
}

.home-discription {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 16px;
  width: 70%;

}

.home-PayStoreBtn {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0px;
  width: 500px;
}

.pay-StoreBtn {
  width: 200px;
  background-color: rgb(238, 238, 238);
  border-radius: 6.5px;
}
@media (max-width: 1200px) {
  .home-styled-content .home-background-phone {
    height: 800px;
    right: 0px;
    top: 100px;
  }
}
@media (max-width: 990px) {
  .home-styled-container {
    padding-bottom: 100px;
  }

  .home-styled-content {
    height: 1000px;
    max-width: 100%;
  }

  .home-main-content {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }

  .home-content-container {
    width: 100%;
  }

  .home-text-container {
    max-width: 100%;
    margin-top: 40px;
  }

  .home-title {
    max-width: 100%;
    font-size: 40px;
    line-height: 55px;
  }

  .home-discription {
    max-width: 50%;
    margin-right: 9px;
  }

  .home-background-circle {
    height: 550px;
    width: 550px;
    border-radius: 500px;
    right: -100px;
    top: 250px;
  }

  .home-content-container {
    padding: 50px 0px 0px 50px;
  }

  .home-styled-content .home-background-phone {
    height: 600px;
  }
}

@media (max-width: 770px) {

  .home-text-container {
    margin-top: 10px;
  }
  .home-PayStoreBtn {
    width: 300px;
  }
  
  .pay-StoreBtn {
    width: 170px;
  }
  .home-styled-content .home-background-phone {
    height: 600px;
    right: 10px;
    top: 400px;
  }

  .home-background-circle {
    right: -100px;
    top: 350px;
  }
}

@media (max-width: 700px) {

  .home-styled-content{
    height: 1100px;
  }
  .home-title {
    max-width: 100%;
    font-size: 32px;
    line-height: 45px;
  }

  .home-discription {
    max-width: 100%;

  }

  .home-text-container {
    margin-top: 10px;
  }

  .home-styled-content .home-background-phone {
    top: 480px;
    right: 0px;
  }

  .home-background-circle {

    right: -130px;
    top: 550px;
  }
  .home-styled-content {
    border-radius: 50px;
  }
  .home-content-container {
    padding:  0px;
  }
}

@media (max-width:1024px){
  .home-styled-content .home-background-phone {
    
    right: -10px;
    top: 150px;
  }
  .home-background-circle { 
    height: 550px;
    width: 550px;
    border-radius: 700px;
    right: -100px;
    top: 300px;
  
  }
  .home-styled-content { 
    height: 750px;
    border-radius: 100px;
    padding: 20px 0px 20px 20px;
  }
}
@media (max-width:770px){
  .home-styled-content .home-background-phone {
    height: 500px;
    right: -10px;
    top: 250px;
  }
}
@media (max-width:480px){
  .home-styled-content .home-background-phone {
    height: 350px;
    right: -10px;
    top: 300px;
  }
  .home-background-circle { 
    height: 350px;
    width: 350px;
    border-radius: 700px;
    right: -50px;
    top: 350px;
  
  }
  .home-styled-content { 
    height: 650px;
    border-radius: 50px;
    padding-bottom: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yDAAuD;EACvD,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6DAA6D;EAC7D,oBAAoB;EACpB,aAAa;EACb,UAAU;;AAEZ;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;IACb,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;;EAEjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;;IAEE,aAAa;IACb,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,UAAU;;EAEZ;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,UAAU;;EAEZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":[".home-styled-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n\r\n}\r\n\r\n.home-styled-content {\r\n  position: relative;\r\n  z-index: 2;\r\n  background-image: url(\"../../assets/images/home-1.png\");\r\n  display: flex;\r\n  width: 100%;\r\n  height: 850px;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  border-radius: 100px;\r\n  padding: 20px 0px 20px 20px;\r\n}\r\n\r\n.home-styled-back {\r\n  z-index: 1;\r\n  position: absolute;\r\n  background-color: #000204;\r\n  width: 100%;\r\n  height: 200px;\r\n}\r\n\r\n.home-background-circle {\r\n  position: absolute;\r\n  z-index: 3;\r\n  height: 850px;\r\n  width: 850px;\r\n  background: linear-gradient(180deg, #0060b3 0%, #000204 100%);\r\n  border-radius: 700px;\r\n  right: -150px;\r\n  top: 100px;\r\n\r\n}\r\n\r\n.home-styled-content .home-background-phone {\r\n  position: absolute;\r\n  \r\n  right: 50px;\r\n  top: -20px;\r\n  z-index: 4;\r\n}\r\n\r\n.home-main-content {\r\n  display: flex;\r\n  gap: 20px;\r\n  position: absolute;\r\n  z-index: 3;\r\n}\r\n\r\n.home-content-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: normal;\r\n  width: 61%;\r\n  margin-left: 0px;\r\n  padding: 100px 0px 0px 100px;\r\n}\r\n\r\n.home-text-container {\r\n  position: relative;\r\n  display: flex;\r\n  margin-top: 29px;\r\n  flex-direction: column;\r\n  font-family: 'Livvic';\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.home-title {\r\n  font-size: 56px;\r\n  font-weight: 700;\r\n  line-height: 63px;\r\n}\r\n\r\n.home-discription {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  margin-top: 16px;\r\n  width: 70%;\r\n\r\n}\r\n\r\n.home-PayStoreBtn {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  margin-top: 0px;\r\n  width: 500px;\r\n}\r\n\r\n.pay-StoreBtn {\r\n  width: 200px;\r\n  background-color: rgb(238, 238, 238);\r\n  border-radius: 6.5px;\r\n}\r\n@media (max-width: 1200px) {\r\n  .home-styled-content .home-background-phone {\r\n    height: 800px;\r\n    right: 0px;\r\n    top: 100px;\r\n  }\r\n}\r\n@media (max-width: 990px) {\r\n  .home-styled-container {\r\n    padding-bottom: 100px;\r\n  }\r\n\r\n  .home-styled-content {\r\n    height: 1000px;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .home-main-content {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 0px;\r\n  }\r\n\r\n  .home-content-container {\r\n    width: 100%;\r\n  }\r\n\r\n  .home-text-container {\r\n    max-width: 100%;\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .home-title {\r\n    max-width: 100%;\r\n    font-size: 40px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .home-discription {\r\n    max-width: 50%;\r\n    margin-right: 9px;\r\n  }\r\n\r\n  .home-background-circle {\r\n    height: 550px;\r\n    width: 550px;\r\n    border-radius: 500px;\r\n    right: -100px;\r\n    top: 250px;\r\n  }\r\n\r\n  .home-content-container {\r\n    padding: 50px 0px 0px 50px;\r\n  }\r\n\r\n  .home-styled-content .home-background-phone {\r\n    height: 600px;\r\n  }\r\n}\r\n\r\n@media (max-width: 770px) {\r\n\r\n  .home-text-container {\r\n    margin-top: 10px;\r\n  }\r\n  .home-PayStoreBtn {\r\n    width: 300px;\r\n  }\r\n  \r\n  .pay-StoreBtn {\r\n    width: 170px;\r\n  }\r\n  .home-styled-content .home-background-phone {\r\n    height: 600px;\r\n    right: 10px;\r\n    top: 400px;\r\n  }\r\n\r\n  .home-background-circle {\r\n    right: -100px;\r\n    top: 350px;\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n\r\n  .home-styled-content{\r\n    height: 1100px;\r\n  }\r\n  .home-title {\r\n    max-width: 100%;\r\n    font-size: 32px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .home-discription {\r\n    max-width: 100%;\r\n\r\n  }\r\n\r\n  .home-text-container {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .home-styled-content .home-background-phone {\r\n    top: 480px;\r\n    right: 0px;\r\n  }\r\n\r\n  .home-background-circle {\r\n\r\n    right: -130px;\r\n    top: 550px;\r\n  }\r\n  .home-styled-content {\r\n    border-radius: 50px;\r\n  }\r\n  .home-content-container {\r\n    padding:  0px;\r\n  }\r\n}\r\n\r\n@media (max-width:1024px){\r\n  .home-styled-content .home-background-phone {\r\n    \r\n    right: -10px;\r\n    top: 150px;\r\n  }\r\n  .home-background-circle { \r\n    height: 550px;\r\n    width: 550px;\r\n    border-radius: 700px;\r\n    right: -100px;\r\n    top: 300px;\r\n  \r\n  }\r\n  .home-styled-content { \r\n    height: 750px;\r\n    border-radius: 100px;\r\n    padding: 20px 0px 20px 20px;\r\n  }\r\n}\r\n@media (max-width:770px){\r\n  .home-styled-content .home-background-phone {\r\n    height: 500px;\r\n    right: -10px;\r\n    top: 250px;\r\n  }\r\n}\r\n@media (max-width:480px){\r\n  .home-styled-content .home-background-phone {\r\n    height: 350px;\r\n    right: -10px;\r\n    top: 300px;\r\n  }\r\n  .home-background-circle { \r\n    height: 350px;\r\n    width: 350px;\r\n    border-radius: 700px;\r\n    right: -50px;\r\n    top: 350px;\r\n  \r\n  }\r\n  .home-styled-content { \r\n    height: 650px;\r\n    border-radius: 50px;\r\n    padding-bottom: 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
